import { useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";

// Detected from the APK; the admin can correct it (empty = back to the detected one).
export const ServerUrl = ({ it, onSaved }) => {
  const { t } = useI18n();
  const [v, setV] = useState(it.server_url || "");
  const save = async () => {
    try {
      const { data } = await api.put(`/admin/atelier/items/${it.id}/server-url`, { server_url: v.trim() });
      onSaved(data);
      setV(data.server_url || "");
      toast.success(t("atelier.saved"));
    } catch (e) { toast.error(translateError(e, t)); }
  };
  return (
    <div className="min-w-0 space-y-1">
      <label htmlFor="atelier-url" className="text-xs font-bold uppercase tracking-wider text-neutral-400">{t("atelier.serverUrl")}</label>
      <div className="flex min-w-0 flex-col gap-2 sm:flex-row">
        <input id="atelier-url" type="url" dir="ltr" value={v} onChange={(e) => setV(e.target.value)} placeholder={t("atelier.urlEmpty")} maxLength={500}
          className="min-w-0 flex-1 rounded-lg border border-neutral-700 bg-black/40 px-3 py-2 text-sm text-white" data-testid="atelier-item-url" />
        <button type="button" className="btn-red btn-sm" onClick={save} data-testid="atelier-item-url-save"><Save className="h-4 w-4" /> {t("atelier.save")}</button>
      </div>
    </div>
  );
};
